/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { blackListsCreateGet } from '../fn/black-lists/black-lists-create-get';
import { BlackListsCreateGet$Params } from '../fn/black-lists/black-lists-create-get';
import { blackListsCreatePost } from '../fn/black-lists/black-lists-create-post';
import { BlackListsCreatePost$Params } from '../fn/black-lists/black-lists-create-post';
import { blackListsDelete } from '../fn/black-lists/black-lists-delete';
import { BlackListsDelete$Params } from '../fn/black-lists/black-lists-delete';
import { blackListsDeleteBlackLists } from '../fn/black-lists/black-lists-delete-black-lists';
import { BlackListsDeleteBlackLists$Params } from '../fn/black-lists/black-lists-delete-black-lists';
import { blackListsGetBlackListAudits } from '../fn/black-lists/black-lists-get-black-list-audits';
import { BlackListsGetBlackListAudits$Params } from '../fn/black-lists/black-lists-get-black-list-audits';
import { blackListsGetBlackListsWithPagination } from '../fn/black-lists/black-lists-get-black-lists-with-pagination';
import { BlackListsGetBlackListsWithPagination$Params } from '../fn/black-lists/black-lists-get-black-lists-with-pagination';
import { blackListsInquireBlackLists } from '../fn/black-lists/black-lists-inquire-black-lists';
import { BlackListsInquireBlackLists$Params } from '../fn/black-lists/black-lists-inquire-black-lists';
import { blackListsUploadFileForInquireBlackLists } from '../fn/black-lists/black-lists-upload-file-for-inquire-black-lists';
import { BlackListsUploadFileForInquireBlackLists$Params } from '../fn/black-lists/black-lists-upload-file-for-inquire-black-lists';
import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfBlackListsWithPaginationDto } from '../models/custom-result-of-black-lists-with-pagination-dto';
import { CustomResultOfListOfInquireBlackListsDto } from '../models/custom-result-of-list-of-inquire-black-lists-dto';

@Injectable({ providedIn: 'root' })
export class BlackListsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `blackListsGetBlackListsWithPagination()` */
  static readonly BlackListsGetBlackListsWithPaginationPath = '/BlackLists/GetBlackListsWithPagination';

  /**
   * GetBlackLists with paging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `blackListsGetBlackListsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  blackListsGetBlackListsWithPagination$Response(params: BlackListsGetBlackListsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfBlackListsWithPaginationDto>> {
    return blackListsGetBlackListsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * GetBlackLists with paging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `blackListsGetBlackListsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  blackListsGetBlackListsWithPagination(params: BlackListsGetBlackListsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfBlackListsWithPaginationDto> {
    return this.blackListsGetBlackListsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfBlackListsWithPaginationDto>): CustomResultOfBlackListsWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `blackListsGetBlackListAudits()` */
  static readonly BlackListsGetBlackListAuditsPath = '/BlackLists/GetBlackListAudits';

  /**
   * Only for pishgam users, Get all audit logs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `blackListsGetBlackListAudits()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  blackListsGetBlackListAudits$Response(params: BlackListsGetBlackListAudits$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return blackListsGetBlackListAudits(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for pishgam users, Get all audit logs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `blackListsGetBlackListAudits$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  blackListsGetBlackListAudits(params: BlackListsGetBlackListAudits$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.blackListsGetBlackListAudits$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `blackListsCreateGet()` */
  static readonly BlackListsCreateGetPath = '/BlackLists/Create';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `blackListsCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  blackListsCreateGet$Response(params?: BlackListsCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return blackListsCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `blackListsCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  blackListsCreateGet(params?: BlackListsCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.blackListsCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `blackListsCreatePost()` */
  static readonly BlackListsCreatePostPath = '/BlackLists/Create';

  /**
   * Create BlackList.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `blackListsCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  blackListsCreatePost$Response(params: BlackListsCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return blackListsCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create BlackList.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `blackListsCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  blackListsCreatePost(params: BlackListsCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.blackListsCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `blackListsDelete()` */
  static readonly BlackListsDeletePath = '/BlackLists';

  /**
   * Delete BlackList.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `blackListsDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  blackListsDelete$Response(params: BlackListsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return blackListsDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete BlackList.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `blackListsDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  blackListsDelete(params: BlackListsDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.blackListsDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `blackListsDeleteBlackLists()` */
  static readonly BlackListsDeleteBlackListsPath = '/BlackLists/DeleteBlackLists';

  /**
   * Delete BlackLists By Mobile Numbers.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `blackListsDeleteBlackLists()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  blackListsDeleteBlackLists$Response(params: BlackListsDeleteBlackLists$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return blackListsDeleteBlackLists(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete BlackLists By Mobile Numbers.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `blackListsDeleteBlackLists$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  blackListsDeleteBlackLists(params: BlackListsDeleteBlackLists$Params, context?: HttpContext): Observable<CustomResult> {
    return this.blackListsDeleteBlackLists$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `blackListsInquireBlackLists()` */
  static readonly BlackListsInquireBlackListsPath = '/BlackLists/InquireBlackLists';

  /**
   * استعلام لیست سیاه شماره ها.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `blackListsInquireBlackLists()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  blackListsInquireBlackLists$Response(params: BlackListsInquireBlackLists$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfInquireBlackListsDto>> {
    return blackListsInquireBlackLists(this.http, this.rootUrl, params, context);
  }

  /**
   * استعلام لیست سیاه شماره ها.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `blackListsInquireBlackLists$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  blackListsInquireBlackLists(params: BlackListsInquireBlackLists$Params, context?: HttpContext): Observable<CustomResultOfListOfInquireBlackListsDto> {
    return this.blackListsInquireBlackLists$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfInquireBlackListsDto>): CustomResultOfListOfInquireBlackListsDto => r.body)
    );
  }

  /** Path part for operation `blackListsUploadFileForInquireBlackLists()` */
  static readonly BlackListsUploadFileForInquireBlackListsPath = '/BlackLists/UploadFileForInquireBlackLists';

  /**
   * آپلود فایل برای استعلام شماره ها.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `blackListsUploadFileForInquireBlackLists()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  blackListsUploadFileForInquireBlackLists$Response(params?: BlackListsUploadFileForInquireBlackLists$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return blackListsUploadFileForInquireBlackLists(this.http, this.rootUrl, params, context);
  }

  /**
   * آپلود فایل برای استعلام شماره ها.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `blackListsUploadFileForInquireBlackLists$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  blackListsUploadFileForInquireBlackLists(params?: BlackListsUploadFileForInquireBlackLists$Params, context?: HttpContext): Observable<CustomResult> {
    return this.blackListsUploadFileForInquireBlackLists$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

}
